<template>
    <div class="nk-content nk-content-fluid">
        <div class="container-xl wide-lg">
            <div class="nk-content-body">
                <!--<div class="nk-block">
                    <div class="row g-gs mb-4">
                        <div class="col-md-12">
                            <div class="card card-bordered card-full">
                                <div class="card-inner">
                                    <div class="row">
                                        <div class="col-lg-4 mb-2">
                                            <div class="card-title">
                                                <h6 class="subtitle">United States Dollar</h6>
                                            </div>
                                            <div class="form-control-wrap">
                                                <div class="input-group">
                                                    <div class="input-group-prepend">
                                                        <button class="btn btn-outline-primary btn-dim">USD</button>
                                                    </div>
                                                    <input v-model="currency.usdAmount" @keyup="UpdateUSD(currency.usdAmount)" type="text" class="form-control">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 mb-2 text-center">
                                            <img src="/images/exchange.png" alt="Alternate Text" style="width: 70px; filter: invert(100%);" />
                                        </div>
                                        <div class="col-lg-4 mb-2">
                                            <div class="card-title">
                                                <h6 class="subtitle">{{currency.toCurrencyCountry}}</h6>
                                            </div>
                                            <div class="form-control-wrap">
                                                <div class="input-group">
                                                    <div class="input-group-prepend">
                                                        <button class="btn btn-outline-primary btn-dim">{{currency.toCurrencyName}}</button>
                                                        <button class="btn btn-icon btn-outline-primary btn-dim dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown">
                                                            <em class="icon ni ni-chevron-down"></em><span class="visually-hidden">Toggle Dropdown</span>
                                                        </button>
                                                        <div class="dropdown-menu">
                                                            <ul class="link-list-opt no-bdr">
                                                                <li v-for="currency in currencyList" :key="currency.id"><a v-on:click="UpdateCurrency(currency)" href="javascript:void(0)">{{currency.money}}</a></li>

                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <input v-model="currency.toCurrencyAmount" @keyup="UpdateOtherCurrency(currency.toCurrencyAmount)" type="text" class="form-control" aria-label="Text input with segmented dropdown button">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>--><!-- .card -->
                        <!--</div>--><!-- .col -->
                    <!--</div>
                </div>-->

                <div class="nk-block">
                    <div class="row g-gs mb-4">
                        <div class="col-md-3">
                            <div class="card card-bordered card-full">
                                <div class="card-inner">
                                    <div class="card-title-group align-start mb-0">
                                        <div class="card-title">
                                            <h6 class="subtitle">Cash Wallet</h6>
                                        </div>
                                        <div class="card-tools">
                                            <em class="card-hint icon ni ni-help-fill" data-bs-toggle="tooltip" data-bs-placement="left" title="Cash Wallet"></em>
                                        </div>
                                    </div>
                                    <div class="card-amount">
                                        <span class="amount">
                                            <span class="currency currency-usd">$</span> {{cashWallet}}
                                        </span>
                                    </div>
                                </div>
                            </div><!-- .card -->
                        </div><!-- .col -->
                        <div class="col-md-3">
                            <div class="card card-bordered  card-full">
                                <div class="card-inner">
                                    <div class="card-title-group align-start mb-0">
                                        <div class="card-title">
                                            <h6 class="subtitle">Package</h6>
                                        </div>
                                        <div class="card-tools">
                                            {{parseFloat(packagePercent).toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}%
                                            <em class="card-hint icon ni ni-arrow-long-up" data-bs-toggle="tooltip" data-bs-placement="left" title="Package"></em>
                                        </div>
                                    </div>
                                    <div class="card-amount">
                                        <div v-if="depositAmount=='ex'" class="spinner-grow" role="status">  <span class="visually-hidden">Loading...</span></div>

                                        <div v-else class="amount">
                                            <div v-if="depositAmount>0">
                                                <span class="currency currency-usd">$</span> {{parseFloat(depositAmount=='ex' ? 0 : depositAmount).toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}
                                            </div>
                                            <span v-else-if="checkExpiredPackage" class="text-danger ms-2 fst-italic">Expired</span>
                                            <span class="currency currency-usd" v-else>$0</span>
                                        </div>

                                    </div>
                                </div>
                            </div><!-- .card -->
                        </div><!-- .col -->

                        <div class="col-md-3">
                            <div class="card card-bordered card-full" v-on:click="TransferModel('Direct')" style="cursor:pointer;">
                                <div class="card-inner" >
                                    <div class="card-title-group align-start mb-0">
                                        <div class="card-title">
                                            <h6 class="subtitle">Direct Bonus</h6>
                                        </div>
                                        <div class="card-tools">
                                            <em class="card-hint icon ni ni-help-fill" data-bs-toggle="tooltip" data-bs-placement="left" title="Direct Bonus"></em>
                                        </div>
                                    </div>
                                    <div class="card-amount">
                                        <span class="amount">
                                            <span class="currency currency-usd">$</span> {{AmountFormat(bonusAmount.directBonus)}}
                                        </span>
                                    </div>
                                </div>
                            </div><!-- .card -->
                        </div><!-- .col -->

                        <div class="col-md-3">
                            <div class="card card-bordered card-full" v-on:click="TransferModel('InDirect')" style="cursor:pointer;">
                                <div class="card-inner">
                                    <div class="card-title-group align-start mb-0">
                                        <div class="card-title">
                                            <h6 class="subtitle">InDirect Bonus</h6>
                                        </div>
                                        <div class="card-tools">
                                            <em class="card-hint icon ni ni-help-fill" data-bs-toggle="tooltip" data-bs-placement="left" title="InDirect Bonus"></em>
                                        </div>
                                    </div>
                                    <div class="card-amount">
                                        <span class="amount">
                                            <span class="currency currency-usd">$</span> {{AmountFormat(bonusAmount.inDirectBonus)}}
                                        </span>
                                    </div>
                                </div>
                            </div><!-- .card -->
                        </div><!-- .col -->

                    </div>

                    <div class="row g-gs mb-4">
                        <div class="col-md-3">
                            <div class="card card-bordered card-full" v-on:click="TransferModel('ROI')" style="cursor:pointer;">
                                <div class="card-inner">
                                    <div class="card-title-group align-start mb-0">
                                        <div class="card-title">
                                            <h6 class="subtitle">ROI Bonus</h6>
                                        </div>
                                        <div class="card-tools">
                                            <em class="card-hint icon ni ni-help-fill" data-bs-toggle="tooltip" data-bs-placement="left" title="ROI Bonus"></em>
                                        </div>
                                    </div>
                                    <div class="card-amount">
                                        <span class="amount">
                                            <span class="currency currency-usd">$</span> {{AmountFormat(bonusAmount.roIBonus)}}
                                        </span>
                                    </div>
                                </div>
                            </div><!-- .card -->
                        </div><!-- .col -->
                        <div class="col-md-3">
                            <div class="card card-bordered card-full" v-on:click="TransferModel('UniLevel')" style="cursor:pointer;">
                                <div class="card-inner">
                                    <div class="card-title-group align-start mb-0">
                                        <div class="card-title">
                                            <h6 class="subtitle">UniLevel Bonus</h6>
                                        </div>
                                        <div class="card-tools">
                                            <em class="card-hint icon ni ni-help-fill" data-bs-toggle="tooltip" data-bs-placement="left" title="UniLevel Bonus"></em>
                                        </div>
                                    </div>
                                    <div class="card-amount">
                                        <span class="amount">
                                            <span class="currency currency-usd">$</span> {{AmountFormat(bonusAmount.uniLevelBonus)}}
                                        </span>

                                    </div>
                                </div>
                            </div><!-- .card -->
                        </div><!-- .col -->

                        <div class="col-md-3">
                            <div class="card card-bordered card-full">
                                <div class="card-inner">
                                    <div class="card-title-group align-start mb-0">
                                        <div class="card-title">
                                            <h6 class="subtitle">SMA Bonus</h6>
                                        </div>
                                        <div class="card-tools">
                                            <em class="card-hint icon ni ni-help-fill" data-bs-toggle="tooltip" data-bs-placement="left" title="SMA Bonus"></em>
                                        </div>
                                    </div>
                                    <div class="card-amount">
                                        <span class="amount">
                                            <span class="currency currency-usd">$</span> {{AmountFormat(bonusAmount.socialMediaBonus)}}
                                        </span>
                                    </div>
                                </div>
                            </div><!-- .card -->
                        </div><!-- .col -->

                        <div class="col-md-3">
                            <div class="card card-bordered card-full">
                                <div class="card-inner">
                                    <div class="card-title-group align-start mb-0">
                                        <div class="card-title">
                                            <h6 class="subtitle">Reward Bonus</h6>
                                        </div>
                                        <div class="card-tools">
                                            <em class="card-hint icon ni ni-help-fill" data-bs-toggle="tooltip" data-bs-placement="left" title="Offer Bonus"></em>
                                        </div>
                                    </div>
                                    <div class="card-amount">
                                        <span class="amount">
                                            <span class="currency currency-usd">$</span> {{offerThisMonth}}
                                        </span>
                                    </div>
                                </div>
                            </div><!-- .card -->
                        </div><!-- .col -->

                    </div>


                    <div class="row g-gs">
                        <div class="col-md-3">
                            <div class="card card-bordered card-full">
                                <div class="card-inner">
                                    <div class="card-title-group align-start mb-0">
                                        <div class="card-title">
                                            <h6 class="subtitle">Total Deposit</h6>
                                        </div>
                                        <div class="card-tools">
                                            <em class="card-hint icon ni ni-help-fill" data-bs-toggle="tooltip" data-bs-placement="left" title="Total Deposited"></em>
                                        </div>
                                    </div>
                                    <div class="card-amount">
                                        <span class="amount">
                                            <span class="currency currency-usd">$</span> {{totalInvest}}
                                        </span>
                                    </div>
                                </div>
                            </div><!-- .card -->
                        </div><!-- .col -->
                        <div class="col-md-3">
                            <div class="card card-bordered  card-full">
                                <div class="card-inner">
                                    <div class="card-title-group align-start mb-0">
                                        <div class="card-title">
                                            <h6 class="subtitle">Total Earning</h6>
                                        </div>
                                        <div class="card-tools">
                                            <em class="card-hint icon ni ni-help-fill" data-bs-toggle="tooltip" data-bs-placement="left" title="Total Earning"></em>
                                        </div>
                                    </div>
                                    <div class="card-amount">
                                        <span class="amount">
                                            <span class="currency currency-usd">$</span> {{AmountFormat(sumTotalEarning + rewardBonus)}}
                                        </span>

                                    </div>
                                </div>
                            </div><!-- .card -->
                        </div><!-- .col -->

                        <div class="col-md-3">
                            <div class="card card-bordered card-full">
                                <div class="card-inner">
                                    <div class="card-title-group align-start mb-0">
                                        <div class="card-title">
                                            <h6 class="subtitle">Total Withdraw</h6>
                                        </div>
                                        <div class="card-tools">
                                            <em class="card-hint icon ni ni-help-fill" data-bs-toggle="tooltip" data-bs-placement="left" title="Total Withdraw"></em>
                                        </div>
                                    </div>
                                    <div class="card-amount">
                                        <span class="amount">
                                            <span class="currency currency-usd">$</span> {{AmountFormat(totalWithdrawal)}}
                                        </span>
                                    </div>
                                </div>
                            </div><!-- .card -->
                        </div><!-- .col -->

                        <div class="col-md-3">
                            <div class="card card-bordered card-full">
                                <div class="card-inner">
                                    <div class="card-title-group align-start mb-0">
                                        <div class="card-title">
                                            <h6 class="subtitle">Business Volume</h6>
                                        </div>
                                        <div class="card-tools">
                                            <em class="card-hint icon ni ni-help-fill" data-bs-toggle="tooltip" data-bs-placement="left" title="Total Withdraw"></em>
                                        </div>
                                    </div>
                                    <div class="card-amount">
                                        <span class="amount">
                                            <span class="currency currency-usd">$</span> {{ businessVolume}}
                                        </span>
                                    </div>
                                </div>
                            </div><!-- .card -->
                        </div><!-- .col -->

                    </div>
                </div>


                <div class="nk-block nk-block-lg">
                    <div class="row gy-gs">
                        <div class="col-md-12">
                            <div class="card-head">
                                <div class="card-title  mb-0">
                                    <h5 class="title">Earning</h5>
                                </div>
                                <div class="card-tools">
                                    <ul class="card-tools-nav">
                                        <li v-bind:class="graphFilter=='Last Year'? 'active' : ''"><a v-on:click="GetGraphSummary('Last Year')" href="javascript:void(0)">Last Year</a></li>
                                        <!--<li v-bind:class="graphFilter=='Last Month'? 'active' : ''"><a v-on:click="GetGraphSummary('Last Month')" href="javascript:void(0)">Last Month</a></li>-->
                                        <li v-bind:class="graphFilter=='Last Week'? 'active' : ''"><a v-on:click="GetGraphSummary('Last Week')" href="javascript:void(0)">Last Week</a></li>
                                        <!--<li v-bind:class="graphFilter=='Today'? 'active' : ''"><a v-on:click="GetGraphSummary('Today')" href="javascript:void(0)">Today</a></li>-->
                                    </ul>
                                </div>
                            </div>
                            <div class="tranx-list card card-bordered">
                                <div id="chart" :key="render">
                                    <apexchart type="area" height="350" :options="chartOptions" :series="series"></apexchart>
                                </div>
                            </div>
                        </div><!-- .col -->
                    </div><!-- .row -->
                </div><!-- .nk-block -->

                <div class="nk-block">
                    <div class="card card-bordered">
                        <div class="card-inner card-inner-lg">
                            <div class="align-center flex-wrap flex-md-nowrap g-4">
                                <div class="nk-block-image w-120px flex-shrink-0">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 118">
                                        <path d="M8.916,94.745C-.318,79.153-2.164,58.569,2.382,40.578,7.155,21.69,19.045,9.451,35.162,4.32,46.609.676,58.716.331,70.456,1.845,84.683,3.68,99.57,8.694,108.892,21.408c10.03,13.679,12.071,34.71,10.747,52.054-1.173,15.359-7.441,27.489-19.231,34.494-10.689,6.351-22.92,8.733-34.715,10.331-16.181,2.192-34.195-.336-47.6-12.281A47.243,47.243,0,0,1,8.916,94.745Z" transform="translate(0 -1)" fill="#f6faff" />
                                        <rect x="18" y="32" width="84" height="50" rx="4" ry="4" fill="#fff" />
                                        <rect x="26" y="44" width="20" height="12" rx="1" ry="1" fill="#e5effe" />
                                        <rect x="50" y="44" width="20" height="12" rx="1" ry="1" fill="#e5effe" />
                                        <rect x="74" y="44" width="20" height="12" rx="1" ry="1" fill="#e5effe" />
                                        <rect x="38" y="60" width="20" height="12" rx="1" ry="1" fill="#e5effe" />
                                        <rect x="62" y="60" width="20" height="12" rx="1" ry="1" fill="#e5effe" />
                                        <path d="M98,32H22a5.006,5.006,0,0,0-5,5V79a5.006,5.006,0,0,0,5,5H52v8H45a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2H73a2,2,0,0,0,2-2V94a2,2,0,0,0-2-2H66V84H98a5.006,5.006,0,0,0,5-5V37A5.006,5.006,0,0,0,98,32ZM73,94v4H45V94Zm-9-2H54V84H64Zm37-13a3,3,0,0,1-3,3H22a3,3,0,0,1-3-3V37a3,3,0,0,1,3-3H98a3,3,0,0,1,3,3Z" transform="translate(0 -1)" fill="#798bff" />
                                        <path d="M61.444,41H40.111L33,48.143V19.7A3.632,3.632,0,0,1,36.556,16H61.444A3.632,3.632,0,0,1,65,19.7V37.3A3.632,3.632,0,0,1,61.444,41Z" transform="translate(0 -1)" fill="#6576ff" />
                                        <path d="M61.444,41H40.111L33,48.143V19.7A3.632,3.632,0,0,1,36.556,16H61.444A3.632,3.632,0,0,1,65,19.7V37.3A3.632,3.632,0,0,1,61.444,41Z" transform="translate(0 -1)" fill="none" stroke="#6576ff" stroke-miterlimit="10" stroke-width="2" />
                                        <line x1="40" y1="22" x2="57" y2="22" fill="none" stroke="#fffffe" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                        <line x1="40" y1="27" x2="57" y2="27" fill="none" stroke="#fffffe" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                        <line x1="40" y1="32" x2="50" y2="32" fill="none" stroke="#fffffe" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                        <line x1="30.5" y1="87.5" x2="30.5" y2="91.5" fill="none" stroke="#9cabff" stroke-linecap="round" stroke-linejoin="round" />
                                        <line x1="28.5" y1="89.5" x2="32.5" y2="89.5" fill="none" stroke="#9cabff" stroke-linecap="round" stroke-linejoin="round" />
                                        <line x1="79.5" y1="22.5" x2="79.5" y2="26.5" fill="none" stroke="#9cabff" stroke-linecap="round" stroke-linejoin="round" />
                                        <line x1="77.5" y1="24.5" x2="81.5" y2="24.5" fill="none" stroke="#9cabff" stroke-linecap="round" stroke-linejoin="round" />
                                        <circle cx="90.5" cy="97.5" r="3" fill="none" stroke="#9cabff" stroke-miterlimit="10" />
                                        <circle cx="24" cy="23" r="2.5" fill="none" stroke="#9cabff" stroke-miterlimit="10" />
                                    </svg>
                                </div>
                                <div class="nk-block-content">
                                    <div class="nk-block-content-head px-lg-4">
                                        <h5>We�re here to help you!</h5>
                                        <p class="text-soft">Ask a question or file a support ticket, manage request, report an issues. Our team support team will get back to you by email.</p>
                                    </div>
                                </div>
                                <div class="nk-block-content flex-shrink-0">
                                    <a href="javascript:void(0)" v-on:click="GetSupport()" class="btn btn-lg btn-outline-primary">Get Support Now</a>
                                </div>
                            </div>
                        </div><!-- .card-inner -->
                    </div><!-- .card -->
                </div><!-- .nk-block -->
            </div>
        </div>
        <roi-fund-transfer-modal :bonusAmount="bonusAmount" :props="prop" :show="show" v-if="show" @close="IsSave" />
    </div>

</template>

<script>
    import VueApexCharts from 'vue-apexcharts'
    export default {
        components: {
            apexchart: VueApexCharts,
        },
        name: 'Dashboard',
        data: function () {
            return {
                render: 0,
                currencyList: [],
                displayUserName: 'ex',
                depositAmount: 'ex',
                packagePercent: 0,
                totalInvest: 0,
                sumTotalEarning: 0,
                totalWithdrawal: 0,
                businessVolume: 0,
                offerThisMonth: 0,
                rewardBonus: 0,

                activePackage: 0,
                directUser: 0,
                cashWallet: 0,
                roiWallet: 0,
                day: 0,

                lastLogin: '',
                prop: '',
                graphFilter: 'Last Week',

                show: false,
                loading: false,
                checkExpiredPackage: false,

                bonusAmount: {
                    directBonus: 0,
                    inDirectBonus: 0,
                    uniLevelBonus: 0,
                    roIBonus: 0,
                    socialMediaBonus: 0,
                    poolBonus: 0,
                },

                currency: {
                    usdAmount: 1,
                    toCurrencyCountry: '',
                    toCurrencyName: '',
                    toCurrencyAmount: 0,
                    toCurrencyRate: 0,
                },


                series: [{
                    name: 'Bonus Earning',
                    data: []
                }],
                chartOptions: {
                    colors: ['#f2bd12', '#f2bd12', '#f2bd12'],
                    chart: {
                        height: 350,
                        type: 'area'
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        curve: 'smooth'
                    },
                    xaxis: {
                        type: '',
                        categories: []
                    },
                },
            }
        },
        methods: {
            UpdateCurrency: function (currency) {
                debugger;
                this.currency.toCurrencyCountry = currency.name;
                this.currency.toCurrencyName = currency.money;
                this.currency.toCurrencyRate = currency.rate;
                this.currency.toCurrencyAmount = parseFloat(currency.rate * this.currency.usdAmount).toFixed(2);

            },

            UpdateUSD: function (value) {
                debugger;
                this.currency.toCurrencyAmount = parseFloat(this.currency.toCurrencyRate * value).toFixed(2);
            },
            UpdateOtherCurrency: function (value) {
                debugger;
                if (this.currency.toCurrencyName != '') {
                    this.currency.usdAmount = parseFloat((parseFloat(value == '' || value == null || value == undefined) ? 0 : value) / parseFloat(this.currency.toCurrencyRate)).toFixed(2);
                }
            },

            GetSupport: function () {
                this.$router.push('/Tickets');
            },

            IsSave: function () {
                this.show = false;
                this.GetReportSammary();
            },

            TransferModel: function (prop) {
                if (prop == 'ROI' || prop == 'UniLevel') {
                    if (this.day == 1) {
                        this.prop = prop;
                        this.show = true;
                    }
                }
                else {
                    this.prop = prop;
                    this.show = true;
                }
            },

            AmountFormat: function (amount) {
                return parseFloat(amount).toFixed(2);
            },

            GetGraphSummary: function (graphFilter) {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                this.graphFilter = graphFilter;
                root.$https.get('/Report/GetGraphSummary?id=' + localStorage.getItem('UserID') + '&graphFilter=' + graphFilter, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {
                        root.series[0].data = [];
                        root.chartOptions.xaxis.categories = [];

                        response.data.forEach(function (item) {
                            root.series[0].data.push(item.debit);
                            root.chartOptions.xaxis.categories.push(item.day);

                        });
                        root.render++;
                    }
                }).catch(error => {
                    console.log(error)
                });
            },


            GetReportSammary: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get('/Report/UserDashboardReport', { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {

                        localStorage.setItem('PackagePlanAmount', response.data.depositAmount);

                        root.depositAmount = response.data.depositAmount;
                        root.packagePercent = response.data.packagePercent;
                        root.totalInvest = response.data.totalInvestment;
                        root.sumTotalEarning = response.data.sumTotalEarning;
                        root.totalWithdrawal = response.data.totalWithdrawal;
                        root.businessVolume = response.data.businessVolume;
                        root.offerThisMonth = response.data.offerThisMonth;
                        root.rewardBonus = response.data.rewardBonus;

                        root.bonusAmount.directBonus = response.data.directBonus;
                        root.bonusAmount.inDirectBonus = response.data.inDirectBonus;
                        root.bonusAmount.uniLevelBonus = response.data.uniLevelBonus;
                        root.bonusAmount.roIBonus = response.data.roIBonus;
                        root.bonusAmount.socialMediaBonus = response.data.socialMediaBonus;
                        root.checkExpiredPackage = response.data.checkExpiredPackage;

                        root.cashWallet = parseFloat(response.data.cashWallet).toFixed(2);

                        root.series[0].data = [];
                        root.chartOptions.xaxis.categories = [];

                        response.data.graphTransactions.forEach(function (item) {
                            root.series[0].data.push(item.debit);
                            root.chartOptions.xaxis.categories.push(item.day);
                        });
                        root.render++;
                    }
                }).catch(error => {
                    console.log(error)
                });
            },

            GetSystemDate: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get('/Company/GetSystemDate', { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {

                        root.day = response.data;
                    }
                }).catch(error => {
                    console.log(error)
                });
            },

            GetCurrency: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get('/Company/CurrencyList?isDropDown=true', { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {
                        root.currencyList = response.data.results;
                        var currency = root.currencyList.find(x => x.money == 'PKR');
                        if (currency != undefined) {
                            root.currency.toCurrencyCountry = currency.name;
                            root.currency.toCurrencyName = currency.money;
                            root.currency.toCurrencyRate = currency.rate;
                            root.currency.toCurrencyAmount = parseFloat(currency.rate * root.currency.usdAmount).toFixed(2);

                        }
                    }
                }).catch(error => {
                    console.log(error)
                });
            },
        },
        created: function () {

        },
        mounted: function () {
            this.GetReportSammary();
            this.GetSystemDate();
            this.GetCurrency();
            this.displayUserName = localStorage.getItem('UserName');
        },
    }
</script>